module.exports = __webpack_public_path__ + "img/comments.5ad6fc99.png";